import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function getWhatsAppLink(mobileNumber: string) {
  const international = parsePhoneNumberFromString(mobileNumber, 'DE')?.formatInternational().replace('+', '').replace(new RegExp(' ', 'g'), '');
  return `https://api.whatsapp.com/send?phone=${international}`;
}
